import React, { useState } from 'react';
import { LeftOutlined, LoginOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input, message, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import './styles.less';
import { useHistory } from 'react-router';
import { AppName, authBackgroundImg, VALIDATE_REQUIRED } from '@/config';
import LanguageSelector from '@/components/app/LanguageSelector';
import { apiSdk } from '@/httpClient';
export const authLogo = require('@/assets/logos/applogo.png');

const ForgotPassword = () => {
  const [t] = useTranslation();
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const login = (email: string) => {
    setLoading(true);
    apiSdk.UserService.forgotPassword({
      email: email,
    })
      .then(res => {
        if (res.success) {
          Modal.info({
            title: t('forgotPasswordPage_TitleForgotPassword'),
            content: <div dangerouslySetInnerHTML={{ __html: t('forgotPasswordPage_ForgotPasswordSuccess', { email: email }) }} />,
          });
        } else {
          message.error(t(res.message || ''));
        }
      })
      .catch(err => {
        message.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div
      className="container-login-form"
      style={{ minHeight: '100vh', backgroundImage: `url(${authBackgroundImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
    >
      <Card className="login-form" bodyStyle={{ padding: 0, border: 'none' }} style={{ border: 'none' }}>
        <Form
          layout="vertical"
          name="normal_login"
          size="large"
          onFinish={values => {
            login(values.email);
          }}
        >
          <div
            style={{
              textAlign: 'center',
              marginBottom: 10,
              paddingTop: 20,
              paddingBottom: 20,
              position: 'relative',
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              backgroundColor: '#dddddd80',
            }}
          >
            <img src={authLogo} alt="auth-logo" style={{ width: 100 }} />
            <span style={{ color: '#0a8ca3', fontSize: 50, marginLeft: 10, textTransform: 'uppercase', fontWeight: 'bold' }}>{AppName}</span>

            <div className="change-language-container">
              <LanguageSelector />
            </div>
          </div>
          <div style={{ padding: 10, paddingBottom: 20 }}>
            <h1 style={{ textAlign: 'center' }}>{t('forgotPasswordPage_TitleForgotPassword')}</h1>
            <h4
              style={{ textAlign: 'center', color: '#666', marginTop: 10 }}
              dangerouslySetInnerHTML={{ __html: t('forgotPasswordPage_ForgotPassword_Hint') }}
            ></h4>
            <Form.Item label={t('forgotPasswordPage_EmailAddress')} name="email" rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
              <Input type="email" placeholder={t('forgotPasswordPage_EmailAddress')} style={{ alignItems: 'center' }} />
            </Form.Item>

            <div style={{ textAlign: 'center', marginTop: 20, marginBottom: 20 }}>
              <Button loading={loading} type="primary" icon={<LoginOutlined />} htmlType="submit" className="login-form-button">
                {t('forgotPasswordPage_Submit')}
              </Button>
            </div>
            <Button
              icon={<LeftOutlined />}
              type="link"
              onClick={() => {
                history.push('/cms/login');
              }}
            >
              {t('forgotPasswordPage_BackToLoginPage')}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};
export default ForgotPassword;
